import PropTypes from 'prop-types';

export default function checker(state) {
  return {
    has(name) {
      return !!state.themes[name];
    },
  };
}

checker.stateTypes = {
  themes: PropTypes.objectOf(PropTypes.object.isRequired).isRequired,
};
